<template>
  <div class="footer">
    <div class="contatosContainer">
      <p class="abrirModal">
        {{$t('webcheckin.contatosEdireitos.algumProblema')}}
        <span class="linkModal" @click="modalAlerta = true">{{$t('webcheckin.contatosEdireitos.cliqueAqui')}}</span>
      </p>
      <v-dialog v-model="modalAlerta" width="80vw" max-width="600px" persistent>
        <div class="modalCentral">
          <h1 class="tituloModal">{{$t('webcheckin.contatosEdireitos.centralDeAtendimento')}}</h1>
          <p class="subtituloModal">{{$t('webcheckin.contatosEdireitos.cliqueLinks')}}</p>

          <div class="gridContatos">
            <component v-for="(contato, index) in contatosApresentados"
                       :key="index"
                       :is="contato.href ? 'a' : 'div'"
                       :href="contato.href || undefined"
                       :target="contato.target || undefined"
                       :rel="contato.target === '_blank' ? 'noopener' : undefined"
                       class="cardContato">
              <span class="iconeWrapper" :style="{ backgroundColor: contato.color + '1a', color: contato.color }">
                <v-icon :color="contato.color" small>{{ contato.icon }}</v-icon>
              </span>
              <span class="labelContato">{{ contato.label }}</span>
            </component>
          </div>

          <button class="buttonFechar" @click="modalAlerta = false">{{$t('webcheckin.contatosEdireitos.fechar')}}</button>
        </div>
      </v-dialog>
    </div>
    <p>{{$t('webcheckin.contatosEdireitos.direitosReservados')}}</p>
  </div>
</template>

<script>
import contatosHotelServices from '../services/ContatoHotel.services'
import { isSocialMedia, isWhatsApp, getContatoApresentacao } from '../utils/redesSociais'

export default {
  data() {
    return {
      contatos: [],
      modalAlerta: false,
    }
  },
  computed: {
    contatosApresentados() {
      const gerais = this.contatos.filter(c => !isSocialMedia(c))
      const sociais = this.contatos
        .filter(isSocialMedia)
        .sort((a, b) => Number(isWhatsApp(a)) - Number(isWhatsApp(b)))
      return [...gerais, ...sociais].map(getContatoApresentacao)
    },
  },
  methods: {
    async buscarContatos() {
      try {
        const res = await contatosHotelServices.buscar()
        this.contatos = res.data
      } catch (error) {
        console.log(error?.response?.message)
      }
    },
  },
  async mounted() {
    await this.buscarContatos()
  },
}
</script>

<style scoped>
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
  background-color: white;
}

p {
  font-size: 10px;
  color: var(--wc-cor-secundaria, #3f4849);
  margin-bottom: 10px;
}

.contatosContainer {
  margin-bottom: 10px;
}

.abrirModal {
  font-size: small;
  font-weight: bold;
}

.linkModal {
  font-size: smaller;
  color: var(--wc-cor-botoes, #156CF7);
  text-decoration: underline;
  cursor: pointer;
}

.modalCentral {
  background-color: white;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 8px;
}

.tituloModal {
  font-size: 20px;
  margin: 0 0 6px 0;
  color: #222;
}

.subtituloModal {
  font-size: 13px;
  margin-bottom: 18px;
  color: #777;
  max-width: 380px;
}

.gridContatos {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
  margin-bottom: 8px;
}

.cardContato {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #fafafa;
  border: 1px solid #ececec;
  border-radius: 10px;
  padding: 10px 14px;
  text-decoration: none;
  color: #333;
  transition: background-color 0.15s, border-color 0.15s, transform 0.15s;
  min-width: 0;
}

a.cardContato {
  cursor: pointer;
}

a.cardContato:hover {
  background-color: #f3f6ff;
  border-color: var(--wc-cor-botoes, #156CF7);
  transform: translateY(-1px);
}

.iconeWrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
}

.labelContato {
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
}

.buttonFechar {
  background-color: var(--wc-cor-botoes, #156CF7);
  color: white;
  border-radius: 10px;
  width: 100%;
  margin-top: 20px;
  padding: 10px;
  font-weight: 600;
}
</style>
